import {
  IonApp,
  IonRouterOutlet,

} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import HomeContent from "../pages/Home/HomeContent";

import { useAuth } from "../contexts/AuthContext";
import Tabs from "./Tabs";
import PrivateRoute from "./PrivateRoute";
import AppUrlListener from "../AppUrlListener";
import { getStudySlug, isSingleStudy } from "../helper/study";



const Navigator: React.FC = () => {
  // For loading state
  const { isInitialized, isAuthenticated } = useAuth();

  const single = isSingleStudy();
  const slug = getStudySlug();

  return (
    <IonApp>
      <IonReactRouter>
        <AppUrlListener />
        <IonRouterOutlet>
          {single ? (
            // Single-study: slug-less landing at "/". Subjects (and, next step, the role
            // links) live at the root; logged-in users go to the slug-prefixed tabs.
            <Route
              exact
              path="/"
              render={() =>
                !isInitialized ? null : isAuthenticated ? (
                  <Redirect to={`/${slug}/tabs/home`} />
                ) : (
                  <HomeContent />
                )
              }
            />
          ) : (
            // Multi-study: no default study at "/", keep the previous redirect behavior.
            <PrivateRoute
              exact
              path="/"
              render={() => <Redirect to={`/${slug}/tabs/home`} />}
            />
          )}

          {/* Single-segment entry (e.g. /mentalplus, /investigator, /parent — also the
              push-notification target). Single mode: the segment selects the role; the study
              slug and unknown segments fall back to the subject landing inside HomeContent.
              Multi mode: the segment is the study slug → redirect to its slug-prefixed welcome.
              Explicit route because IonRouterOutlet doesn't render a pathless fallback. */}
          <Route
            exact
            path="/:entry"
            render={({ match }) =>
              !isInitialized ? null : single ? (
                isAuthenticated ? (
                  <Redirect to={`/${slug}/tabs/home`} />
                ) : (
                  <HomeContent entrySegment={match.params.entry} />
                )
              ) : (
                <Redirect to={`/${match.params.entry}/welcome`} />
              )
            }
          />

          {/* Public landing (slug-prefixed): the multi-study landing route, and the
              slug-prefixed entry that in-app logout/leave redirects and the NoSlug page use.
              Auth-guarded in single mode (like "/" and "/:study_slug") so an authenticated
              user landing here is sent to the app instead of being logged out by
              HomeContent's onboarding effect. */}
          <Route
            exact
            path="/:study_slug/welcome"
            render={() =>
              !isInitialized ? null : single && isAuthenticated ? (
                <Redirect to={`/${slug}/tabs/home`} />
              ) : (
                <HomeContent />
              )
            }
          />

          {/* Authenticated app (slug kept in the URL). */}
          <Route path="/:study_slug/tabs" render={() => <Tabs />} />

          {/* NOTE: a slug-prefixed role entry (/{slug}/investigator) would go here for
              multi-study, but a bare "/:study_slug/:entry" collides with "/:study_slug/tabs"
              and "/:study_slug/welcome" inside IonRouterOutlet and breaks the tabs view.
              Single-study role entries use the slug-less "/:entry" route above; when
              multi-study lands, add a collision-proof form (e.g. "/:study_slug/role/:entry"). */}

          {/* Fallback */}
          <Route>
            {isAuthenticated ? (
              <Redirect to={`/${slug}/tabs/home`} />
            ) : single ? (
              <Redirect to="/" />
            ) : (
              <Redirect to={`/${slug}/welcome`} />
            )}
          </Route>
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  );
};

export default Navigator;
